import * as Yup from 'yup';

export const addFundsValidationSchema = Yup.object().shape({
  funds: Yup.array(
    Yup.object({
      operation: Yup.number().required('Campo obrigatório'),
      quotas: Yup.array(
        Yup.object({
          class: Yup.string().required('Campo obrigatório'),
          series: Yup.string().required('Campo obrigatório'),
          amount: Yup.number()
            .required('Campo obrigatório')
            .min(1, 'Mínimo de 1 cota'),
        }),
      ),
    }),
  ),
});
